import { DateList } from "@/enums/dateList";
import { DateFilter, ExpenseFilter, Filter } from "@/types/filter";

// Helper function to check if a given expense date is within the specified range
const isWithinRange = (expenseDate: Date, filterDate?: string): boolean => {
  if (!filterDate) return true;

  const now = new Date();
  const compareDate = new Date(now);

  switch (filterDate) {
    case DateList.LAST_WEEK:
      compareDate.setDate(now.getDate() - 7);
      break;
    case DateList.LAST_MONTH:
      compareDate.setDate(now.getDate() - 30);
      break;
    case DateList.LAST_THREE_MONTHS:
      compareDate.setMonth(now.getMonth() - 3);
      break;
    case DateList.LAST_SIX_MONTHS:
      compareDate.setMonth(now.getMonth() - 6);
      break;
    case DateList.LAST_YEAR:
      compareDate.setMonth(now.getMonth() - 12);
      break;
    default:
      return true;
  }

  return expenseDate >= compareDate;
};
export function applyExpenseFilters(
  expenses: ExpenseFilter[],
  filter: DateFilter,
) {
  const flatExpenses = Array.isArray(expenses[0]) ? expenses.flat() : expenses;

  return flatExpenses.filter((expense) => {
    if (!expense.date) {
      console.warn("Expense missing date:", expense);
      return false;
    }

    const expenseDate = new Date(expense.date + "T00:00:00.000Z");

    if (isNaN(expenseDate.getTime())) {
      console.warn("Invalid date for expense:", expense.date);
      return false;
    }

    return filter.date.some((dateRange) =>
      isWithinRange(expenseDate, dateRange),
    );
  });
}

export const getFiltersFromUrl = (params: URLSearchParams): Filter => {
  return {
    date: params.get("date") || "",
    startDate: params.get("startDate") || "",
    endDate: params.get("endDate") || "",
    itemsId: params.get("itemsId")?.split(",").map(Number) || [],
    branchId: params.get("branchId")?.split(",").map(Number) || [],
    categoryId: params.get("categoryId")?.split(",").map(Number) || [],
    paymentMethod: params.get("paymentMethod")?.split(",") || [],
    reimbursed: params.get("reimbursed") || "",
    search: params.get("search") || "",
  };
};
